import { connect } from 'react-redux'
import { DevelopmentSiteRedirectPage } from '../components/DevelopmentSiteRedirectPage'
import { siteRoutingActionCreators } from '../modules/developmentSiteView'

export default connect(
  () => ({}),
  siteRoutingActionCreators,
)(DevelopmentSiteRedirectPage)
